import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from '@nolimitcity/promo-panel/bin/interfaces/ASInterfaces';
import {ASBonusPickOptions, WINTYPE} from '@nolimitcity/promo-panel/bin/enums/ASEnums';
import {BaseServerData} from "./server/base/IData";
import { SanGameMode } from './config/base/GameConfig';
import { SoundManager } from './config/sound/SoundManager';
import { SoundConfig } from './config/sound/SoundConfig';
import { SanQuentin2 } from './SanQuentin2';
import { GameAssets } from './config/texture/GameAssets';
import { GameSetting } from '../core/setting/GameSetting';
import { TranslationConfig } from './config/translate/TranslationConfig';

export class SanQ2PromoPanelConfig implements PromoPanelGameConfiguration {
    public getActionSpinOptions(): ActionSpinOptions {
        return {
            hasActionSpin: true,
            gameName: 'SanQuentin2',
            graphics: {
                backgroundTextureName: GameAssets.INTRO_BACKGROUND, 
            },
            // mainGame: {
            //     header: ()=> "xBET",
            //     options: [
            //         {name:"NORMAL", id:0, image:"NORMAL.png"},
            //         {name:"BOOSTED_BET" , id:1, image:"BOOSTED_BET.png"},
            //     ],
            //     type: ASMainGamePickOptions.BOOSTED_BET
            // },
            bonusGame: {
                header: () => SanQuentin2.apiPlugin.translations.translate(TranslationConfig.GREEN_MILE_SPINS),
                options: () => {
                    return [
                        {name: SanQuentin2.apiPlugin.translations.translate(TranslationConfig.COLLECT), id: 1, image: "Collect.png"},
                        {name: SanQuentin2.apiPlugin.translations.translate(TranslationConfig.CHANCE), id: 2, image: "Gamble.png"},
                    ];
                },
                type: ASBonusPickOptions.PICK_MODE,
                pickNeededForModes: [SanGameMode.FREESPIN_SETUP1],
                pickNeededForBuyFeatures: [ "FREESPIN_3_SCATTERS","FREESPIN_4_SCATTERS","FREESPIN_5_SCATTERS", "LUCKY_DRAW"] //Needs to be the actual feature name used by server.
            },
            getParsedData: (response: BaseServerData, bet: number, prevResponse: BaseServerData): ASWinData => {

                const spinWin = this.getSpinWin(response, bet, prevResponse);

                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.featureBuy,
                    freeSpinTriggeredThisSpin: this.isFreespinTriggeredThisSpins(response),
                    totalSpinWinnings: spinWin,
                    isBigWin: this.isBigWin(response, spinWin),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false,
                    waitForAnimation: this.isBigWin(response, spinWin)
                };
                return parsedData;
            },
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SoundManager.playSoundEffect(SoundConfig.HIGHLIGHTWIN_COMMON);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.playSoundEffect(SoundConfig.BIG_WIN_ENDS);
        }
    }

    private getSpinWin(response: BaseServerData, bet: number, prevData: BaseServerData): number {
        let win = response ? response.totalSpinWinnings : 0;
        win = win ?? 0;
        return win;
    }

    private isFreespinTriggeredThisSpins(response: BaseServerData) {
        return response.mode === SanGameMode.NORMAL && response.nextMode != SanGameMode.NORMAL;
    }

    private isBigWin(response: BaseServerData, spinWin: number): boolean {
        const BWThreshold: number = 15;
        let winRatio: number = spinWin / response.playedBetValue;

        if (response.featureBuy || response.boostedBet){
            const betPrice = SanQuentin2.model.getBuyFeaturePrice / response.playedBetValue
            winRatio = winRatio / (betPrice < BWThreshold ? BWThreshold : betPrice);
            return winRatio >= 1;
        }

        return winRatio >= BWThreshold;
    }

    private getFeatureName(response: BaseServerData): string {

        if(response.mode === SanGameMode.FREESPIN_SETUP1){
            return GameSetting.translate(TranslationConfig.GREEN_MILE_SPINS)
            // if(response.nextMode === SanGameMode.NORMAL)
            //     return GameSetting.translate(TranslationConfig.GREEN_MILE_SPINS)
            // else
            //     return GameSetting.translate("Pick Bonus Mode")
        }

        if(response.nextMode === SanGameMode.FREESPIN_SETUP1){
            if(response.mode === SanGameMode.NORMAL){
                return GameSetting.translate("Pick Bonus Mode")
            }
            if(response.numJumpingWilds != 5)
                return GameSetting.translate("GREEN MILE GAMBLE: "+["E","D","C","B","A"][response.nextSetupLevel-1]);
            else
                return GameSetting.translate(TranslationConfig.GAMBLE_MAX_WIN);
        }

        else if(response.mode === SanGameMode.FREESPIN || response.nextMode === SanGameMode.FREESPIN){
            return GameSetting.translate(GameSetting.translate(TranslationConfig.GREEN_MILE_SPINS));
        }

        
        return response.mode;
    }

    private isRoundComplete(response: BaseServerData): boolean {
        return !![SanGameMode.FREESPIN_SETUP1, SanGameMode.FREESPIN_SETUP2, SanGameMode.FREESPIN, SanGameMode.NORMAL].find((v ) => v === response.nextMode) 
    }

    private isBonusEnd(response: BaseServerData): boolean {
        return response.nextMode === SanGameMode.NORMAL && response.mode === SanGameMode.FREESPIN;
    }
}
